// Client-side domain models for the tenant-scoped background library document instruction edit process.
// Mirrors the backend AIProcessType.LibraryDocumentInstructionEdit process state. Execution runs in the
// browser (SuperDoc); the backend owns durable process truth. See the DocumentJobHostProvider.

// Detailed lifecycle stage (stored in the process Data). Numeric values match the backend enum.
export enum LibraryDocumentInstructionEditStage {
  Prepared = 0,
  ClientRunning = 1,
  Saving = 2,
  Completed = 3,
  Failed = 4,
  Canceled = 5,
}

// Coarse run status. Numeric values match the backend ProcessRunStatus enum.
export enum LibraryDocumentInstructionEditRunStatus {
  NotStarted = 0,
  InProgress = 1,
  Completed = 2,
  Canceled = 3,
  Failed = 4,
}

export enum LibraryDocumentInstructionEditRestartMode {
  None = 0,
  Restart = 1,
}

export interface LibraryDocumentInstructionEditStatus {
  exists: boolean;
  externalId: string;
  libraryLinkId: number;
  libraryListId: number;
  title?: string;
  status: LibraryDocumentInstructionEditRunStatus;
  stage: LibraryDocumentInstructionEditStage;
  runId?: string;
  attemptCount: number;
  startedByUserId?: string;
  lastClaimedByUserId?: string;
  workerHeartbeat?: Date;
  heartbeatStale: boolean;
  started?: Date;
  modified?: Date;
  completed?: Date;
  startedSharePointVersion?: string;
  startedSharePointModified?: Date;
  savedSharePointVersion?: string;
  savedSharePointModified?: Date;
}

// Prepared payload the frontend needs to ingest and run, plus the conflict flag and current status.
export interface LibraryDocumentInstructionEditStartResult {
  started: boolean;
  conflict: boolean;
  status?: LibraryDocumentInstructionEditStatus;
  runId?: string;
  libraryLinkId?: number;
  libraryListId?: number;
  driveItemId?: string;
  title?: string;
  pendingInstruction?: string;
}

export interface LibraryDocumentInstructionEditTransitionResult {
  applied: boolean;
  conflict: boolean;
  status?: LibraryDocumentInstructionEditStatus;
}
